import React from 'react'
import Navbar from './Navbar'
import style from './Food.module.css'
import {  } from 'react-router-dom'

import Category from './Category';

const Food = () => {
 
    
  return (
    <>
    <Navbar/>
    
      <div className={style.hero_section}>
        <h2 className={style.hero_title}>Nutrition is the foundation where wellness begins.</h2>
        <p className={style.hero_text}>
         Your body thrives when you nourish it with purpose—choose foods that support strength, healing, and energy, and let daily nutrition guide you toward long-lasting wellness.
        </p>
      </div>
      <Category/>
      
      </>
  )
}

export default Food